var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "139.388 512.59 61.381 27.209",
    width: 61.381,
    height: 27.209,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "matrix(1.333333, 0, 0, -1.333333, 195.681059, 539.798934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -38.403 c -2.108,0 -3.817,1.709 -3.817,3.816 v 12.775 c 0,2.107 1.709,3.816 3.817,3.816 H 0 c 2.108,0 3.816,-1.709 3.816,-3.816 V 3.816 C 3.816,1.709 2.108,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 122.239,55.67 h 1.889 v -1.889 h -1.889 z m 0,4.88 h 1.889 v -1.889 h -1.889 z",
    style: {
      fill: "#121b22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30",
    transform: "matrix(1.333333, 0, 0, -1.333333, 0, 604.723999)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "matrix(1.333333, 0, 0, -1.333333, 175.683726, 532.176538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 2.598,0 4.392,1.889 4.392,4.471 4.392,7.084 2.598,8.973 0,8.973 -2.598,8.973 -4.408,7.084 -4.408,4.471 -4.408,1.889 -2.598,0 0,0 m 0,10.548 c 3.353,0 6.061,-2.708 6.061,-6.061 0,-3.354 -2.708,-6.061 -6.061,-6.061 -3.353,0 -6.061,2.707 -6.061,6.061 0,3.353 2.708,6.061 6.061,6.061",
    style: {
      fill: "#121b22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "matrix(1.333333, 0, 0, -1.333333, 193.00066, 522.520935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0.945 -0.866,1.732 -1.968,1.732 -1.165,0 -1.889,-0.709 -1.889,-1.653 0,-0.866 0.551,-1.48 1.81,-1.811 0.425,-0.11 0.851,-0.204 1.26,-0.299 1.574,-0.378 2.834,-1.354 2.834,-3.322 0,-1.731 -1.417,-3.432 -3.857,-3.432 -2.141,0 -3.983,1.669 -4.015,3.432 l 1.653,0.63 c -0.031,-1.558 1.181,-2.471 2.362,-2.471 1.338,0 2.204,0.739 2.204,1.841 0,1.181 -1.024,1.575 -1.811,1.732 -0.378,0.079 -0.866,0.205 -1.259,0.331 -1.496,0.456 -2.834,1.48 -2.834,3.447 0,1.811 1.559,3.117 3.542,3.117 2.047,0 3.7,-1.385 3.7,-3.274 z",
    style: {
      fill: "#121b22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "matrix(1.333333, 0, 0, -1.333333, 150.746522, 526.194137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 5.839,-5.838 h 2.066 v 0.331 L 2.398,0 Z",
    style: {
      fill: "#00b0ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "matrix(1.333333, 0, 0, -1.333333, 152.509329, 518.112941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.353,0 -6.061,-2.708 -6.061,-6.061 0,-3.353 2.708,-6.061 6.061,-6.061 0.707,0 1.385,0.121 2.015,0.342 l -1.284,1.284 C 0.495,-10.53 0.251,-10.548 0,-10.548 c -2.598,0 -4.408,1.889 -4.408,4.471 0,2.614 1.81,4.503 4.408,4.503 2.598,0 4.392,-1.889 4.392,-4.503 0,-0.288 -0.022,-0.568 -0.066,-0.837 l 1.331,-1.33 c 0.261,0.677 0.404,1.413 0.404,2.183 C 6.061,-2.708 3.353,0 0,0",
    style: {
      fill: "#121b22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c3b98467820b36ed7e4088a7bebd2fe5.svg";
export { ForwardRef as ReactComponent };